
import axios from "axios";
import moment from "moment";
export const state = () => ({
  filter: {
    type: [], // list int
    user_guids: [], // list string
    admin_user_guid: [], // list string
    source: [], // list string
    created_time_type: 4,
    last_updated_time_type: 4,
    status: [], // list int
    sla_status: [],
    search: "",
    search_member_id: "",
    search_name: "",
    search_tel_email: "",
    page: 1,
    take: 10,
    onlyMe: 0,
    sortColumnId: 0, // 1 = created_time, 2 = updated_time
    sortType: true, // true = ASC, false = DESC
    createdDateFrom: moment().subtract(1, "month").format("YYYY-MM-DD"),
    createdDateTo: moment().format("YYYY-MM-DD"),
    lastUpdatedDateFrom: moment().subtract(1, "month").format("YYYY-MM-DD"),
    lastUpdatedDateTo: moment().format("YYYY-MM-DD"), // Type DateTime
  },
});

export const mutations = {
  setFilterTicket: async function (state, val) {
    console.log(val, state, "state");
    state.filter = val;
  },
};

export const actions = {
  filterTicket: async ({ commit }, payload) => {
    console.log(payload, "payload");
    commit("setFilterTicket", payload);
  },
};

export default {
  state,
  actions,
  mutations,
};
